import router from '../router';
import store from '../store';
import { ROUTE_VALIDATION_ORDER as routeOrder } from './constants';

/**
 * Returns the first invalid route up to the given route name.
 * If no route name is provided, the current route name is used.
 * If there is no invalid route up to the given route name, the route name is
 * returned.
 *
 * @param routeName Route name to get the valid route to
 * @returns {*|string} Route name
 */
export default function (routeName) {
  routeName = routeName || router.currentRoute.name;
  const invalidRouteIndex = routeOrder.indexOf(
    store.getters['application/getFirstInvalidRoute']
  );
  const currentRouteIndex = routeOrder.indexOf(routeName);
  if (invalidRouteIndex < currentRouteIndex) {
    return routeOrder[invalidRouteIndex];
  }
  return routeName;
}
